
export default {
  name: 'CourseOverview'
}
